import React, { Component } from 'react';
import {Modal} from 'react-bootstrap';

class RequestToJoinOrgErrorMessageModal extends Component {

	handleOk = (event) => {
		event.preventDefault();
		this.props.closeRequestToJoinOrgErrorMessageModal();
	}

	render () {

		return (
			<Modal onHide={this.props.closeRequestToJoinOrgErrorMessageModal} show={this.props.showRequestToJoinOrgErrorMessageModal} aria-labelledby="ModalHeader">
            	<Modal.Header closeButton>
              		<Modal.Title id='ModalHeader'>FirstNet Developer Program</Modal.Title>
            	</Modal.Header>
            	<Modal.Body>
					{this.props.requestToJoinOrgErrorMessage}
            	</Modal.Body>
            	<Modal.Footer>
              		<button className='btn btn-primary' onClick={this.handleOk} name="Ok">
                		Ok
              		</button>
            	</Modal.Footer>
          </Modal>
		)
	}
}

export default RequestToJoinOrgErrorMessageModal;



// WEBPACK FOOTER //
// ./src/manageOrg/RequestToJoinOrgErrorMessageModal.js